// Shared Morpheus flag-threshold semantics.
//
// A zero cost variance is never a variance flag. This matters when operators use
// 0 / 0 thresholds to mean "flag any non-zero variance": without the explicit
// sign guard, every perfectly matched counted row satisfies both <= 0 and >= 0
// and the UI incorrectly reports every counted item as flagged.
export function resolveCostVarianceFlagState(costVariance, flagConfig = {}) {
  const value = Number(costVariance);
  const safeValue = Number.isFinite(value) ? value : 0;

  const negativeRaw = Number(flagConfig?.negativeFlagThreshold);
  const positiveRaw = Number(flagConfig?.positiveFlagThreshold);
  const negativeThreshold = Number.isFinite(negativeRaw) ? negativeRaw : -300;
  const positiveThreshold = Number.isFinite(positiveRaw) ? positiveRaw : 300;

  const negativeFlagged = safeValue < 0 && safeValue <= negativeThreshold;
  const positiveFlagged = safeValue > 0 && safeValue >= positiveThreshold;

  return {
    negativeFlagged,
    positiveFlagged,
    thresholdFlagged: negativeFlagged || positiveFlagged,
  };
}

export function hasZeroCostVarianceFlagBoundary(flagConfig = {}) {
  return Number(flagConfig?.negativeFlagThreshold) === 0 || Number(flagConfig?.positiveFlagThreshold) === 0;
}
